const VAYU_RECOVERY_NAMESPACE = 'vayu-blocks/';

const recoverBlock = ({ name, attributes, innerBlocks }) => {
  try {
    return wp.blocks.createBlock(name, attributes || {}, innerBlocks || []);
  } catch {
    return null;
  }
};

const recursivelyRecoverInvalidBlockList = (blocks) => {
  const _blocks = [...blocks];
  let recoveryCalled = false;

  const recursivelyRecover = (items) => {
    for (const block of items) {
      if (block?.name?.startsWith(VAYU_RECOVERY_NAMESPACE) && block?.isValid === false) {
        const newBlock = recoverBlock(block);
        if (newBlock) {
          Object.assign(block, newBlock);
          recoveryCalled = true;
        }
      }
      if (Array.isArray(block.innerBlocks) && block.innerBlocks.length > 0) {
        recursivelyRecover(block.innerBlocks);
      }
    }
  };

  recursivelyRecover(_blocks);
  return [_blocks, recoveryCalled];
};

const recoverBlocks = (blocks) => {
  return blocks.map((block) => {
    try {
      if (block.name === 'core/block') {
        const ref = block.attributes?.ref;
        if (!ref) return block;

        const reusablePost = wp.data
          .select('core')
          .getEditedEntityRecord('postType', 'wp_block', ref);

        if (!reusablePost?.content?.raw) return block;

        const parsedBlocks = wp.blocks.parse(reusablePost.content.raw);
        const vayuBlocks = parsedBlocks.filter(b => b.name?.startsWith(VAYU_RECOVERY_NAMESPACE));
        const [recoveredBlocks, recovered] = recursivelyRecoverInvalidBlockList(vayuBlocks);

        if (recovered) {
          return {
            blocks: recoveredBlocks,
            isReusable: true,
            ref,
          };
        }
        return block;
      }

      if (Array.isArray(block.innerBlocks) && block.innerBlocks.length > 0) {
        const newInner = recoverBlocks(block.innerBlocks);
        if (newInner.some((b) => b.recovered)) {
          block.innerBlocks = newInner;
          block.replacedClientId = block.clientId;
          block.recovered = true;
        }
      }

      if (!block.isValid && block.name?.startsWith(VAYU_RECOVERY_NAMESPACE)) {
        const newBlock = recoverBlock(block);
        if (newBlock) {
          newBlock.replacedClientId = block.clientId;
          newBlock.recovered = true;
          return newBlock;
        }
      }

      return block;
    } catch {
      return block;
    }
  });
};

wp.data.subscribe(() => {
  try {
    if (!wp?.blocks || !wp?.data || !window.vayublock?.options?.global?.autoRecovery) return;

    const beSel = wp.data.select('core/block-editor');   // no editor fallback
    const beDisp = wp.data.dispatch('core/block-editor');
    const coreDisp = wp.data.dispatch('core');

    const blocks = beSel?.getBlocks?.() || [];
    if (!Array.isArray(blocks)) return;

    // Skip while the user is typing
    if (typeof beSel.isTyping === 'function' && beSel.isTyping()) return;

    // Hash block clientIds to run only on structure changes
    const clientIds = (function flatIds(list) {
      const ids = [];
      (function walk(items){ items.forEach(b => { ids.push(b.clientId); if (b.innerBlocks?.length) walk(b.innerBlocks); }); })(list);
      return ids;
    })(blocks).join(',');
    const hash = btoa(clientIds);
    if (hash === window.__VAYU_RECOVERY_HASH__) return;

    // Quick check: proceed only if there are invalid Vayu blocks anywhere
    let hasInvalid = false;
    (function scan(items){
      for (const b of items) {
        if (b?.name?.startsWith('vayu-blocks/') && b?.isValid === false) { hasInvalid = true; return; }
        if (b.innerBlocks?.length) scan(b.innerBlocks);
      }
    })(blocks);
    if (!hasInvalid) { window.__VAYU_RECOVERY_HASH__ = hash; return; }

    // Preserve viewport and current selection
    const scrollHost = document.querySelector('.interface-interface-skeleton__content');
    const y = scrollHost ? scrollHost.scrollTop : window.scrollY;
    const selectedBefore = beSel.getSelectedBlockClientId();

    // Recover
    let recoveryCount = 0; // optional if you still want stats
    let recoveredTop = recoverBlocks(blocks); // uses your existing function

    // 1) Persist reusable block updates (top-level markers you created)
    for (const block of recoveredTop) {
      if (block?.isReusable && block?.ref && Array.isArray(block.blocks)) {
        try {
          coreDisp.editEntityRecord('postType', 'wp_block', block.ref, {
            content: wp.blocks.serialize(block.blocks),
          });
          // optionally persist immediately:
          // wp.data.dispatch('core').saveEditedEntityRecord('postType','wp_block', block.ref);
        } catch (e) {
          console.warn(`[ Failed to Update Reusable] Ref: ${block.ref}`, e);
        }
      }
    }

    // 2) Replace all recovered blocks (flatten so nested ones are handled)
    const flatRecovered = (function flat(list){
      const out = [];
      (function walk(items){
        items.forEach(b => {
          out.push(b);
          if (b.innerBlocks?.length) walk(b.innerBlocks);
        });
      })(list);
      return out;
    })(recoveredTop).filter(b => b?.recovered && b?.replacedClientId);

    // Track if the selected block got replaced
    let replacementForSelected = null;

    for (const b of flatRecovered) {
      try {
        if (b.replacedClientId === selectedBefore) replacementForSelected = b;
        beDisp.replaceBlock(b.replacedClientId, b);
        wp.data.dispatch('core/notices').removeNotice('block-invalid-' + b.replacedClientId);
        recoveryCount++;
      } catch (e) {
        console.warn(`[Failed to Replace Block] ${b.name}`, e);
      }
    }

    // Restore viewport and (only if needed) selection
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (scrollHost) scrollHost.scrollTop = y; else window.scrollTo(0, y);
        if (replacementForSelected?.clientId) {
          // Reselect the replacement of the previously selected block
          beDisp.selectBlock(replacementForSelected.clientId);
        }
      });
    });

    // Mark processed structure
    window.__VAYU_RECOVERY_HASH__ = hash;

  } catch (e) {
    console.error('[Recovery Error]', e);
  }
});
